import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-multi-station-pre-registration",
	templateUrl: "./multi-station-pre-registration.component.html",
	styleUrls: ["./multi-station-pre-registration.component.css"],
})
export class MultiStationPreRegistrationComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
